module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTP///////////////////////////////xb9HQ4AAAAIdFJOUwDhYEAhgLtQ19ZdTQAAAHBJREFUKM9jYBhMgC0BQ4hRgJ5C7CkQITcFuBBTowNIiEUCIcQQIQIScmxF0sna6MAowCIRgGxahAijAIoikDJHEVRFDAwago2taM5i6ugIQHeqRiuG69kNyAhkZ2MoMIELdcBAI1yoSAkK1AdN6gAA3x4UUfkBzSkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/downicon.png
// module id = F6qk
// module chunks = 1